export interface ITimer {
    name: string;
    duration: number;
    start: number;
}

export interface ILink {
    rel: string;
    link: string;
    type: string;
}

export interface ITeam {
    links: ILink[];
    name: string;
    slug: string;
    settings: ISettings;
    timer?: ITimer;
}

export interface ISettings {
    focus: number;
    pause: number;
}


export const DefaultSettings = {
    focus: 25,
    pause: 5,
} as ISettings;

export const DefaultTeam = {
    links: [],
    name: '',
    settings: DefaultSettings,
    slug: '',
} as ITeam;

export interface IError {
    message: string;
}

export class ErrorCouldNotFindTeam implements IError {
    public readonly team: string;
    public readonly message: string;

    constructor(team: string) {
        this.team = team;
        this.message = 'Could not find team';
    }
}

export const NewErrorCouldNotFindTeam = (team: string): ErrorCouldNotFindTeam => new ErrorCouldNotFindTeam(team)

const isNullOrUndefined = (value: any): boolean => value === null || value === undefined

export const isEqual = (a: ISettings, b: ISettings): boolean => {
    if(isNullOrUndefined(a) && !isNullOrUndefined(b)) {
        return false;
    }

    if(!isNullOrUndefined(a) && isNullOrUndefined(b)) {
        return false;
    }

    if(isNullOrUndefined(a) && isNullOrUndefined(b)) {
        return true;
    }

    if(a.focus !== b.focus) {
        return false;
    }

    if(a.pause !== b.pause) {
        return false;
    }

    return true;
};

export interface IJoinTeamSuccess {
    payload: ITeam,
    type: string
}



// WEBPACK FOOTER //
// ./src/redux/modules/team/types.ts